import React from "react";
import Icon from "@ant-design/icons";

const DashBoardSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path stroke="currentColor" d="M3 3h5v5H3V3z"></path>
      <path stroke="currentColor" d="M3 12H8V17H3z"></path>
      <path stroke="currentColor" d="M12 3H17V8H12z"></path>
      <path stroke="currentColor" d="M17 17.5V12h-5v5h2.5"></path>
    </svg>
  );
};

const MessagesSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="currentColor"
      d="M17 10v7m-7 0h4.5M17 10a7 7 0 10-7 7M8 10h5"
    ></path>
  </svg>
);

const ScheduleSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="currentColor"
      d="M14.54 16.588a8 8 0 111.803-1.712M9.5 6v5l3.5 2.5"
    ></path>
  </svg>
);

const LibrarySvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="currentColor"
      d="M4.5 5.363V17l5.5-4 5.5 4V5.363M4 3h12"
    ></path>
  </svg>
);

const TimeEstimateSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M13 16.1973C12.1175 16.7078 11.0929 17 10 17C6.68629 17 4 14.3137 4 11C4 7.68629 6.68629 5 10 5C13.3137 5 16 7.68629 16 11C16 12.2267 15.6318 13.3675 15 14.3178"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path d="M8.5 3H11.5" stroke="currentColor" strokeLinecap="round" />
    <path d="M10 3V5" stroke="currentColor" />
    <path d="M4 5.5L5.5 4" stroke="currentColor" strokeLinecap="round" />
    <path d="M14.5 4L16 5.5" stroke="currentColor" strokeLinecap="round" />
    <path
      d="M10 8V11.5L12 13"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const OptionSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99984 10.8333C10.4601 10.8333 10.8332 10.4602 10.8332 9.99992C10.8332 9.53968 10.4601 9.16658 9.99984 9.16658C9.5396 9.16658 9.1665 9.53968 9.1665 9.99992C9.1665 10.4602 9.5396 10.8333 9.99984 10.8333Z"
      fill="#667085"
    />
    <path
      d="M9.99984 4.99992C10.4601 4.99992 10.8332 4.62682 10.8332 4.16659C10.8332 3.70635 10.4601 3.33325 9.99984 3.33325C9.5396 3.33325 9.1665 3.70635 9.1665 4.16659C9.1665 4.62682 9.5396 4.99992 9.99984 4.99992Z"
      fill="#667085"
    />
    <path
      d="M9.99984 16.6666C10.4601 16.6666 10.8332 16.2935 10.8332 15.8333C10.8332 15.373 10.4601 14.9999 9.99984 14.9999C9.5396 14.9999 9.1665 15.373 9.1665 15.8333C9.1665 16.2935 9.5396 16.6666 9.99984 16.6666Z"
      fill="#667085"
    />
    <path
      d="M9.99984 10.8333C10.4601 10.8333 10.8332 10.4602 10.8332 9.99992C10.8332 9.53968 10.4601 9.16658 9.99984 9.16658C9.5396 9.16658 9.1665 9.53968 9.1665 9.99992C9.1665 10.4602 9.5396 10.8333 9.99984 10.8333Z"
      stroke="#667085"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99984 4.99992C10.4601 4.99992 10.8332 4.62682 10.8332 4.16659C10.8332 3.70635 10.4601 3.33325 9.99984 3.33325C9.5396 3.33325 9.1665 3.70635 9.1665 4.16659C9.1665 4.62682 9.5396 4.99992 9.99984 4.99992Z"
      stroke="#667085"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99984 16.6666C10.4601 16.6666 10.8332 16.2935 10.8332 15.8333C10.8332 15.373 10.4601 14.9999 9.99984 14.9999C9.5396 14.9999 9.1665 15.373 9.1665 15.8333C9.1665 16.2935 9.5396 16.6666 9.99984 16.6666Z"
      stroke="#667085"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PinIconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00012 9.99992L8.00012 14.6666M5.33346 4.87201V6.29242C5.33346 6.4311 5.33346 6.50044 5.31985 6.56676C5.30777 6.6256 5.2878 6.68254 5.26047 6.73603C5.22966 6.79633 5.18635 6.85047 5.09972 6.95876L4.0532 8.26691C3.60937 8.82169 3.38746 9.09908 3.38721 9.33253C3.38699 9.53556 3.4793 9.72762 3.63797 9.85428C3.82042 9.99992 4.17566 9.99992 4.88612 9.99992H11.1141C11.8246 9.99992 12.1798 9.99992 12.3623 9.85428C12.5209 9.72762 12.6133 9.53556 12.613 9.33253C12.6128 9.09908 12.3909 8.82169 11.947 8.26691L10.9005 6.95876C10.8139 6.85047 10.7706 6.79633 10.7398 6.73603C10.7125 6.68254 10.6925 6.6256 10.6804 6.56676C10.6668 6.50044 10.6668 6.4311 10.6668 6.29242V4.87201C10.6668 4.79526 10.6668 4.75688 10.6711 4.71904C10.675 4.68542 10.6814 4.65214 10.6903 4.6195C10.7003 4.58275 10.7146 4.54712 10.7431 4.47586L11.415 2.79607C11.611 2.30601 11.709 2.06098 11.6682 1.86428C11.6324 1.69227 11.5302 1.54132 11.3838 1.44425C11.2163 1.33325 10.9524 1.33325 10.4246 1.33325H5.57563C5.04782 1.33325 4.78391 1.33325 4.61646 1.44425C4.47003 1.54132 4.36783 1.69227 4.33209 1.86428C4.29122 2.06098 4.38923 2.30601 4.58525 2.79607L5.25717 4.47586C5.28567 4.54712 5.29992 4.58275 5.30995 4.6195C5.31886 4.65214 5.32526 4.68542 5.32912 4.71904C5.33346 4.75688 5.33346 4.79526 5.33346 4.87201Z"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DashBoardIcon = (props) => {
  return <Icon component={DashBoardSvg} {...props} />;
};

const MessagesIcon = (props) => {
  return <Icon component={MessagesSvg} {...props} />;
};

const ScheduleIcon = (props) => {
  return <Icon component={ScheduleSvg} {...props} />;
};

const LibraryIcon = (props) => {
  return <Icon component={LibrarySvg} {...props} />;
};

const TimeEstimateIcon = (props) => {
  return <Icon component={TimeEstimateSvg} {...props} />;
};

const OptionIcon = (props) => {
  return <Icon component={OptionSvg} {...props} />;
};

const PinIcon = (props) => {
  return <Icon component={PinIconSvg} {...props} />;
};

export {
  DashBoardIcon,
  MessagesIcon,
  ScheduleIcon,
  LibraryIcon,
  TimeEstimateIcon,
  OptionIcon,
  PinIcon,
};
